define("ember-svg-jar/inlined/settings", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#a)\"><path d=\"M16 4l.895 2.992 2.763-1.478 2.828 2.829L21 11.097 24 12v4l-3 .903 1.486 2.754-2.828 2.828-2.763-1.477L16.001 24h-4l-.912-2.992-2.746 1.477-2.829-2.828 1.47-2.754L4 16v-4l2.984-.903-1.469-2.754 2.828-2.829 2.747 1.478L12 4h4zm-2 6a4 4 0 10.001 8 4 4 0 000-8z\"/></g><defs><clipPath id=\"a\"><path d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "fill": "currentColor",
      "viewBox": "0 0 28 28"
    }
  };
});